// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TableMobileRow_row__3PUB3 td {\n  padding: 0px;\n}\n.TableMobileRow_titre__3N1QI td {\n  padding: 8px 12px;\n}\n.TableMobileRow_titre__3N1QI > td,\n.TableMobileRow_row__3PUB3:last-child > td {\n  border-bottom: none;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Table/TableMobileRow.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,mBAAmB;AACrB","sourcesContent":[".row td {\n  padding: 0px;\n}\n.titre td {\n  padding: 8px 12px;\n}\n.titre > td,\n.row:last-child > td {\n  border-bottom: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": "TableMobileRow_row__3PUB3",
	"titre": "TableMobileRow_titre__3N1QI"
};
export default ___CSS_LOADER_EXPORT___;
